import { api } from './api';

export const vendorSubscriptionService = {
    list: (params = {}) => {
        const q = new URLSearchParams();
        if (params.plan) q.set('plan', params.plan);
        if (params.status) q.set('status', params.status);
        if (params.q) q.set('q', params.q);
        if (params.page) q.set('page', String(params.page));
        if (params.limit) q.set('limit', String(params.limit));
        const qs = q.toString();
        return api.get(`/api/admin/vendor-subscriptions${qs ? `?${qs}` : ''}`);
    },
    detail: (vendorId) => api.get(`/api/admin/vendor-subscriptions/${vendorId}`),
    grantComp: (vendorId, body) => api.post(`/api/admin/vendor-subscriptions/${vendorId}/comp`, body),
    revokeComp: (vendorId) => api.post(`/api/admin/vendor-subscriptions/${vendorId}/comp/revoke`),
    refund: (vendorId, body) => api.post(`/api/admin/vendor-subscriptions/${vendorId}/refund`, body),
    runMaintenance: () => api.post('/api/admin/vendor-subscriptions/maintenance'),
    getConfig: () => api.get('/api/admin/vendor-subscriptions/config'),
    putConfig: (body) => api.put('/api/admin/vendor-subscriptions/config', body),
};
